import { Model, MapTo } from 'src/app/decorators/mapto';

import { NotificationModel } from './notification.model';

export class NotificationsModel extends Model {
    @MapTo()
    count: number;
    @MapTo('notification', [NotificationModel])
    notification: NotificationModel[];

    constructor(payload: any) {
        super(payload);
        this.setValues(payload);
    }
}
